<template>
  <div class="chapter-indicators__container">
    <div
      v-for="(chapter, index) in episodeChapters"
      :key="'indicator-' + index"
      :class="classes"
      :style="`left: ${getLeftPosition(chapter.startTime)}%`"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('player', ['chapters', 'currentEpisode']),

    episodeDuration () {
      return this.currentEpisode.itunes_duration
    },

    episodeChapters () {
      return this.chapters
    },

    classes () {
      return [
        'chapter-indicators__indicator',
        `chapter-indicators__indicator-${this.isFullScreen ? 'full-screen' : 'default'}`
      ]
    }
  },
  methods: {
    getLeftPosition (chapterStartTime) {
      return chapterStartTime / this.episodeDuration * 100
    }
  }
}
</script>

<style lang="scss" scoped>
.chapter-indicators {
  &__container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  &__indicator {
    position: absolute;
    width: 2px;
    top: 0;
    bottom: 0;

    &-full-screen {
      background-color: #BDBDBD;
    }

    &-default {
      background-color: #6c26d6;
    }
  }
}
</style>
